<template>
  <v-card-actions
    :class="'py-0' + (showBenchmark ? ' cursor-pointer' : '')"
    @click.stop="showRankingList"
  >
    <v-row>
      <v-col
        cols="auto"
        class="caption"
        v-bind:style="{
          color: getColor($vuetify.theme.themes.light.secondarytext, 0.5)
        }"
      >
        <v-icon
          :color="getColor($vuetify.theme.themes.light.secondarytext, 0.5)"
        >
          insert_chart
        </v-icon>
        <template v-if="coreCard && coreCard.excludeFromRanking">
          Excluded from rankings
        </template>
        <template v-else-if="alternateText">
          Benchmarks aren't available for {{ alternateText }}
        </template>
        <template v-else-if="coreCard && coreCard.rankTotal == 1">
          Benchmark is unavailable due to group size
        </template>
        <template v-else-if="coreCard && !coreCard.isEmpty">
          Benchmark is
          {{ benchmark }} in this group
        </template>
        <template v-else>
          There is no data to display yet
        </template>
      </v-col>
      <v-spacer></v-spacer>
      <v-col
        cols="auto"
        v-if="showRank && showBenchmark && coreCard.rankTotal > 1"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              outlined
              :color="getColor($vuetify.theme.themes.light.secondarytext, 0.5)"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="mr-2" small>security</v-icon>
              {{ coreCard.rank }} of {{ coreCard.rankTotal }}
            </v-chip>
          </template>
          <span class="pa-2">Ranks #{{ coreCard.rank }} In Group</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <core-card-ranking-dialog ref="ranking"></core-card-ranking-dialog>
  </v-card-actions>
</template>

<script>
import CoreCardRankingDialog from "@/components/corecard/CoreCardRankingDialog";
export default {
  name: "CoreCardFooter",
  components: { CoreCardRankingDialog },
  props: {
    coreCard: { type: Object },
    isPercent: { type: Boolean, default: false },
    showRank: { type: Boolean, default: false },
    alternateText: { type: String },
    filter: { type: Object },
    round: { type: Boolean, default: false }
  },
  computed: {
    showBenchmark() {
      return (
        this.coreCard &&
        !this.coreCard.isEmpty &&
        !this.alternateText &&
        !this.coreCard.excludeFromRanking
      );
    },
    benchmark() {
      if (this.isPercent) {
        return `${Math.round(this.coreCard.benchmark)}%`;
      } else if (this.round) {
        return Math.round(this.coreCard.benchmark);
      }
      return this.coreCard.benchmark.toFixed(1);
    }
  },
  methods: {
    showRankingList() {
      if (!this.showBenchmark) {
        return;
      }
      this.$refs.ranking.showDialog(this.filter);
    }
  }
};
</script>
